<kendo-grid *ngIf="gridData || loading" #grid [loading]="loading" [resizable]="true" [data]="gridData?.dataSourceResult"
  (detailExpand)="detailExpandGrid($event)" [pageable]="{
    buttonCount: 5,
    info: true,
    type: 'numeric',
    pageSizes: true,
    previousNext: true,
    position: 'bottom'
  }" [pageSize]="state?.take" [skip]="state?.skip" [sortable]="true" [sort]="state?.sort" [filter]="state?.filter"
  (dataStateChange)="onDataStateChangeBase($event)" [columnMenu]="menuSettings" [autoSize]="true" filterable="menu"
  scrollable="none" class="shared-grid">
  <ng-template kendoGridToolbarTemplate>
    <ng-container *ngIf="showAddButton()">
      <button
        *ngIf="(!canSelectAgency || (!!currentAgency?.locationKey && currentAgency.locationKey !== '0'))  && (!isEi() || isDohmhRole())"
        kendoButton [svgIcon]="svgPlus" size="medium" rounded="large" fillMode="solid" themeColor="info"
        (click)="addToGrid.emit(canSelectAgency ? currentAgency?.locationKey : user?.selectedLocation?.locationCode)"
        [disabled]="viewMode">
        {{ addButtonText }}
      </button>
    </ng-container>

    <ng-container *ngIf="canSelectAgency">
      <span>Agency: </span>
      <kendo-dropdownlist #agencyDropdown *ngIf="canSelectAgency" [data]="filteredAgency()" [textField]="'locationName'"
        [valueField]="'locationKey'"
        [defaultItem]="{ locationName: 'Select an Agency in order to add a child', id: null, locationKey: null }"
        [filterable]="true" [kendoDropDownFilter]="filterSettings" [(ngModel)]="currentAgency" [style.width]="'350px'"
        (valueChange)="closeRowsAndSendRequest()" [disabled]="filteredAgency()?.length === 1">
        <!-- couldn't get width otherwise -->
      </kendo-dropdownlist>
    </ng-container>

    <kendo-grid-spacer></kendo-grid-spacer>
    <button *ngIf="gridApiRoute === eventLog" kendoButton [svgIcon]="refreshIcon" title="Refresh"
      class="actions-btn-cls" (click)="this.refreshGrid()"></button>
    <button kendoGridExcelCommand themeColor="base" class="right-toolbar-button excel-btn" fillMode="solid"
      [disabled]="viewMode">
      Export to Excel
    </button>
    <button kendoButton themeColor="base" (click)="resetGrid()" class="right-toolbar-button excel-btn" fillMode="solid"
      [disabled]="viewMode">
      Clear All Filters
    </button>
  </ng-template>
  <ng-container *ngFor="let col of columnDefinitions">
    <kendo-grid-column *ngIf="col.columnType === columnTypeEnum.text" field="{{ col.field }}" title="{{ col.title }}"
      [sortable]="true" [autoSize]="true" [hidden]="col.hidden" [headerClass]="'grid-header'" [width]="col.width">
      <ng-template *ngIf="col.field === studentName" kendoGridCellTemplate let-data>
        <div kendoTypography variant="h6" class="student-name k-cursor-pointer text-overflow"
          (click)="routeToStudentProfile(data.studentSk, data.nycId)">
          {{ data.studentName }}
        </div>
        <div class="student-id">{{ data.nycId ?? data.eId }}</div>
      </ng-template>
      <ng-template *ngIf="col.field === 'eventSubject'" kendoGridCellTemplate let-data>
        <div kendoTypography variant="h6" class="student-name k-cursor-pointer k-white-space-normal">
          {{ data.eventSubject }}
        </div>
        <div class="student-id" *ngIf="data?.documentDetails?.length">
          <div *ngFor="let file of data?.documentDetails">
            <a (click)="viewDocument(file)" class="doc-name text-elipsis">
              {{ file.documentFileName }}
            </a>
          </div>
        </div>
      </ng-template>

      <ng-template kendoGridFilterMenuTemplate let-filter let-column="column" let-filterService="filterService">
        <kendo-grid-string-filter-menu [column]="column" [filter]="filter" [filterService]="filterService"
          [extra]="false">
          <kendo-filter-contains-operator></kendo-filter-contains-operator>
        </kendo-grid-string-filter-menu>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column *ngIf="col.columnType === columnTypeEnum.numeric" field="{{ col.field }}" title="{{ col.title }}"
      filter="date" [sortable]="true" [autoSize]="true" [hidden]="col.hidden" [headerClass]="'grid-header'"
      [width]="col.width">
      <ng-template kendoGridCellTemplate let-data>
        <div [class]="(data[col.field] < 0 ? 'negative-value': '')">{{ data[col.field] }}</div>
      </ng-template>


      <ng-template kendoGridFilterMenuTemplate let-filter let-column="column" let-filterService="filterService">
        <kendo-grid-numeric-filter-menu [column]="column" [filter]="filter" [filterService]="filterService"
          [extra]="false">
          <kendo-filter-gte-operator></kendo-filter-gte-operator>
          <kendo-filter-lte-operator></kendo-filter-lte-operator>
        </kendo-grid-numeric-filter-menu>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column *ngIf="col.columnType === columnTypeEnum.date" field="{{ col.field }}" title="{{ col.title }}"
      filter="date" [sortable]="true" [autoSize]="true" [hidden]="col.hidden" [headerClass]="'grid-header'"
      [width]="col.width">
      <ng-template kendoGridCellTemplate let-data>
        {{ getDate(data[col.field]) | date : "MM/dd/yyyy" }}
      </ng-template>

      <ng-template kendoGridFilterMenuTemplate let-filter let-column="column" let-filterService="filterService">
        <kendo-grid-date-filter-menu [column]="column" [filter]="filter" [filterService]="filterService"
          [extra]="false">
          <kendo-filter-after-eq-operator></kendo-filter-after-eq-operator>
        </kendo-grid-date-filter-menu>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column *ngIf="col.columnType === columnTypeEnum.dateTime" field="{{ col.field }}"
      title="{{ col.title }}" filter="date" [sortable]="true" [autoSize]="true" [hidden]="col.hidden"
      [headerClass]="'grid-header'" [width]="col.width">
      <ng-template kendoGridCellTemplate let-data>
        {{ getDate(data[col.field]) | date : "MM/dd/yyyy, h:mm a" }}
      </ng-template>

      <ng-template kendoGridFilterMenuTemplate let-filter let-column="column" let-filterService="filterService">
        <kendo-grid-date-filter-menu [column]="column" [filter]="filter" [filterService]="filterService"
          [extra]="false">
          <kendo-filter-after-eq-operator></kendo-filter-after-eq-operator>
        </kendo-grid-date-filter-menu>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column *ngIf="col.columnType === columnTypeEnum.select" field="{{ col.field }}" title="{{ col.title }}"
      [sortable]="true" [autoSize]="true" [headerClass]="'grid-header'" [hidden]="col.hidden">
      <ng-template *ngIf="col.field === 'activityStatus'" kendoGridCellTemplate let-data>
        <div>{{ data.activityStatusText }}</div>
        <app-compliance-status-cell [complianceStatus]="data.complianceStatus"
          [daysPastCompliance]="data.daysPastCompliance" [daysPastPolicyCompliance]="data.daysPastPolicyCompliance">
        </app-compliance-status-cell>
      </ng-template>
      <ng-template *ngIf="col.field === locationCode && gridApiRoute === eitransition" kendoGridCellTemplate let-data>
        <div kendoTooltip class="text-overflow" title="{{ getAgencyById(data.locationCode) }}">
          {{ getAgencyById(data.locationCode) }}
        </div>
      </ng-template>

      <ng-template kendoGridCellTemplate let-data>
        <div kendoTooltip class="text-overflow" title="{{
            getReferenceDataById(data[col.field], col.referenceDataItems)?.description ?? data[col.field]
          }}">
          {{ getReferenceDataById(data[col.field], col.referenceDataItems)?.description ?? data[col.field] }}
        </div>
      </ng-template>

      <ng-template kendoGridFilterMenuTemplate let-filter="filter" let-filterService="filterService">
        <app-droplist-filter *ngIf="!col.referenceDataItems?.length" [field]="col.field" [currentFilter]="filter"
          [filterService]="filterService" [textField]="col.field" [valueField]="col.field"
          [data]="gridData.distinctFieldValues[col.field]"></app-droplist-filter>

        <app-droplist-filter *ngIf="col.referenceDataItems?.length" [field]="col.field" [currentFilter]="filter"
          [filterService]="filterService" [textField]="'description'" [valueField]="'id'"
          [data]="gridData.distinctFieldValues[col.field]"></app-droplist-filter>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column *ngIf="col.columnType === columnTypeEnum.icon" field="{{ col.field }}"
      title="{{ col.title === '' ? 'Actions' :  col.title}}" [sortable]="false" [autoSize]="true" [hidden]="col.hidden"
      [width]="col.width ?? 60" [headerClass]="col.title === '' ? 'action-column' : 'grid-header'" [resizable]="true">
      <ng-template kendoGridCellTemplate let-data let-rowIndex="rowIndex">
        <app-action-cell *ngIf="data.eventType !== 'System Generated'" (refreshGrid)="refreshGrid()" [icon]="col.icon!"
          [actions]="data.actions" [module]="gridApiRoute" [referralSk]="data.referralSk"
          [sharePersonallyIdentifiableInformation]="
            data.sharePersonallyIdentifiableInformation
          " [nycId]="data.nycId" [studentGrade]="data.studentGrade" [declassificationId]="data.declassificationId"
          [ineligibilitySk]="data.inEligibilitySk" [complianceDate]="data.complianceDate" [studentSk]="data.studentSk"
          [pwnType]="data.pwnType" [declassificationPwnSk]="data.declassficationPwnSk" [outreachSk]="data.outreachSk"
          [iepFormSk]="data.iepFormSk" [consentSk]="data.consentSk" [ineligibilityPwnSk]="data.inEligibilityPwnSk"
          [meetingSk]="data.meetingSk" [allConsentsSk]="getAllConsentSk(data)" [allOutreachSk]="getAllOutreachSk(data)"
          [activity]="data.activity" [preSchoolSummarySk]="data.preSchoolSummarySk" [evaluationSk]="data.evaluationSk"
          [iepType]="data.iepType" [isEi]="isEi()"
          [viewMode]="viewMode">
        </app-action-cell>
      </ng-template>
    </kendo-grid-column>
    <ng-template kendoGridLoadingTemplate>
      <div class="k-loading-color"></div>
      <div class="loading-container">
        <kendo-loader type="converging-spinner" size="large"></kendo-loader>
      </div>
    </ng-template>
    <ng-template kendoGridNoRecordsTemplate>
      <ng-container *ngIf="gridData">
        <div>
          <kendo-badge-container>
            <kendo-svg-icon [icon]="cloudIcon" size="large"></kendo-svg-icon>
            <kendo-badge position="inside" themeColor="error">
              <kendo-svg-icon [icon]="xIcon"></kendo-svg-icon>
            </kendo-badge>
          </kendo-badge-container>
        </div>
        <p>There is no data to display.</p>
      </ng-container>
    </ng-template>
    <ng-template *ngIf="expandedRowColumnDefinitions" let-data kendoGridDetailTemplate>
      <kendo-grid
        [data]="isEi() ? nestedGridData[data.studentSk] : nestedGridData | sortByEiDocumentTypePipe : referenceData?.eiDocumentTypes"
        scrollable="none">
        <ng-container *ngFor="let col of expandedRowColumnDefinitions">
          <kendo-grid-column [field]="col.field" [title]="col.title" [sortable]="col.sortable"
            [headerClass]="'grid-header'" [autoSize]="col.autoSize" [width]="col.width">
            <ng-container [ngSwitch]="col.columnType">
              <ng-container *ngSwitchDefault>
                <ng-template kendoGridCellTemplate let-dataItem>
                  <div>
                    {{ dataItem[col.field] }}
                  </div>
                  <ng-container *ngIf="dataItem['documentComment']">
                    <div class="document-comment">
                      Reason: {{ dataItem["documentComment"] }}
                    </div>
                  </ng-container>
                </ng-template>

                <ng-template kendoGridFilterMenuTemplate let-filter let-column="column"
                  let-filterService="filterService">
                  <kendo-grid-string-filter-menu [column]="column" [filter]="filter" [filterService]="filterService"
                    [extra]="false">
                    <kendo-filter-contains-operator></kendo-filter-contains-operator>
                  </kendo-grid-string-filter-menu>
                </ng-template>
              </ng-container>

              <ng-container *ngSwitchCase="columnTypeEnum.date">
                <ng-template kendoGridCellTemplate let-dataItem>
                  {{ (dataItem.document?.[col.field] ?? dataItem[col.field]) | date: 'MM/dd/yyyy' }}
                </ng-template>

                <ng-template kendoGridFilterMenuTemplate let-filter let-column="column"
                  let-filterService="filterService">
                  <kendo-grid-string-filter-menu [column]="column" [filter]="filter" [filterService]="filterService"
                    [extra]="false">
                    <kendo-filter-after-eq-operator></kendo-filter-after-eq-operator>
                  </kendo-grid-string-filter-menu>
                </ng-template>
              </ng-container>

              <ng-container *ngSwitchCase="columnTypeEnum.file">
                <ng-template kendoGridCellTemplate let-dataItem>
                  <a *ngIf="col.field === documentName" class="doc-name" (click)="viewDocument(dataItem.document)">
                    {{ dataItem.document?.[col.field] ?? dataItem[col.field] }}</a>
                </ng-template>

                <ng-template kendoGridFilterMenuTemplate let-filter let-column="column"
                  let-filterService="filterService">
                  <kendo-grid-string-filter-menu [column]="column" [filter]="filter" [filterService]="filterService"
                    [extra]="false">
                    <kendo-filter-after-eq-operator></kendo-filter-after-eq-operator>
                  </kendo-grid-string-filter-menu>
                </ng-template>
              </ng-container>

              <ng-container *ngSwitchCase="columnTypeEnum.select">
                <ng-template kendoGridCellTemplate let-dataItem [ngSwitch]="col.field">


                  <!-- TODO @sandesh temporary until we have metadata to retrieve -->
                  <ng-container *ngSwitchCase="'documentType'">
                    <div *ngIf="!!dataItem?.otherEIType">
                      {{ getReferenceDataById(+dataItem?.[col.field], col.referenceDataItems)?.description }}
                    </div>
                    <a class="doc-name" (click)="viewDocument(dataItem)">
                      {{
                      !!dataItem.otherEIType ? dataItem.otherEIType : getReferenceDataById(+dataItem?.[col.field],
                      col.referenceDataItems)?.description
                      }}
                    </a>
                  </ng-container>

                  <ng-container *ngSwitchCase="'documentStatus'">
                    <div>
                      {{getReferenceDataById(+dataItem?.[col.field], col.referenceDataItems)?.description}}
                    </div>
                  </ng-container>

                  <div kendoTooltip class="text-overflow" *ngSwitchDefault
                    title="{{ dataItem.document?.[col.field] ?? dataItem[col.field] }}">
                    {{ dataItem?.document?.[col.field] ?? dataItem[col.field] }}
                  </div>
                </ng-template>

                <ng-template kendoGridFilterMenuTemplate let-filter="filter" let-filterService="filterService">

                  <app-droplist-filter *ngIf="!col.referenceDataItems?.length" [field]="col.field"
                    [currentFilter]="filter" [filterService]="filterService" [textField]="col.field"
                    [valueField]="col.field" [data]="getSelectFilterData(col)"></app-droplist-filter>

                  <app-droplist-filter *ngIf="col.referenceDataItems?.length" [field]="col.field"
                    [currentFilter]="filter" [filterService]="filterService" [textField]="'description'"
                    [valueField]="'id'" [data]="getSelectFilterData(col)"></app-droplist-filter>

                </ng-template>
              </ng-container>
              <ng-container *ngSwitchCase="columnTypeEnum.icon">
                <ng-template kendoGridCellTemplate let-dataItem>
                  <app-action-cell *ngIf="dataItem.actions?.length" [icon]="col.icon!" [actions]="dataItem.actions"
                    [module]="gridNestedApiRoute" [documentData]="dataItem.document ?? dataItem"
                    [studentSk]="data.studentSk" [nycId]="data.eId" [pwnType]="data.pwnType"
                    [outreachSk]="data.outreachSk" [studentId]="data.nycId" [dueDate]="dataItem.dueDate"
                    [studentName]="data.studentName" [expandedRowData]="data.expandedRow" [evaluationSk]="
                      dataItem.evaluationName === socialHistoryEvaluation ||
                      dataItem.evaluationName === socialHistoryUpdate
                        ? dataItem.referralSk
                        : dataItem.evaluationSk
                    " [referralSk]="dataItem.referralSk" [evaluationDataRoute]="evaluationDataRoute(dataItem)"
                    [activity]="data.activity" (refreshGrid)="sendEiNestedRequest(dataItem.studentSk, true)">
                  </app-action-cell>
                </ng-template>
              </ng-container>
            </ng-container>
          </kendo-grid-column>
        </ng-container>

        <ng-template kendoGridNoRecordsTemplate>
          <div>
            <kendo-badge-container>
              <kendo-svg-icon [icon]="cloudIcon" size="large"></kendo-svg-icon>
              <kendo-badge position="inside" themeColor="error">
                <kendo-svg-icon [icon]="xIcon"></kendo-svg-icon>
              </kendo-badge>
            </kendo-badge-container>
          </div>
          <div class="k-pt-2">There is no data to display.</div>
          <!-- TODO use the css library for styles -->
        </ng-template>
      </kendo-grid>
    </ng-template>
  </ng-container>
  <kendo-grid-excel *ngIf="gridApiRoute === eitransition" fileName="{{ gridApiRoute }}.xlsx" [fetchData]="allData">
    <kendo-excelexport-column *ngFor="let column of columnDefinitions" [field]="column.field"
      [title]="column.title"></kendo-excelexport-column>
  </kendo-grid-excel>

  <kendo-grid-excel *ngIf="gridApiRoute === eventLog" fileName="{{ gridApiRoute }}.xlsx" [fetchData]="allData">
    <kendo-excelexport-column *ngFor="let column of columnDefinitions" [field]="column.field"
      [title]="column.title"></kendo-excelexport-column>
  </kendo-grid-excel>

</kendo-grid>